import "./DeleteForm.css";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningIcon from "@mui/icons-material/Warning";
import PrimaryButton from "../../Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../FormModal/FormModal";
import CloseIcon from "@mui/icons-material/Close";

function DeleteForm({
  setGo,
  buttonText = "Delete",
  title = "",
  onClick,
  icon = false,
  classes = "",
}) {
  const [Open, setOpen] = useState(false);

  return (
    <div>
      {icon ? (
        <button
          className="removeSchoolButton"
          onClick={() => setOpen(true)}
          title="Unassign school from course"
        >
          <CloseIcon />
        </button>
      ) : (
        <button
          className={`deleteActionButton ${classes}`}
          onClick={() => setOpen(true)}
        >
          {buttonText}
        </button>
      )}

      <FormModal
        Open={Open}
        HandleClose={() => setOpen(false)}
        XButton={false}
        Form={
          <div className="deleteModalContent">
            <div className="deleteWarningSection">
              <div className="warningIcon">
                <WarningIcon />
              </div>
              <div className="warningText">
                <h3>Confirm {buttonText}</h3>
                <p>{title}</p>
              </div>
            </div>

            <div className="deleteActionButtons">
              <button className="cancelButton" onClick={() => setOpen(false)}>
                Cancel
              </button>
              <button
                className="confirmDeleteButton"
                onClick={(e) => {
                  if (onClick) onClick(e);
                  else setGo(true);
                  setOpen(false);
                }}
              >
                <DeleteIcon sx={{ fontSize: "20px" }} />
                {buttonText}
              </button>
            </div>
          </div>
        }
        Title=""
        CustomStyle="deleteModal"
      />
    </div>
  );
}

export default DeleteForm;
